/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for setOperationDuplicates. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="setOperationDuplicates"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="remove"/&gt; &lt;enumeration value="preserve"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class SetOperationDuplicates extends Enum{

	enumValue = null;

	static  REMOVE = SetOperationDuplicates.newLiteral("remove");

	static  PRESERVE = SetOperationDuplicates.newLiteral("preserve");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	static fromValue(v) {
		for (var i = 0; (i < SetOperationDuplicates.values().length); ++i) {
			if (SetOperationDuplicates.values()[i].enumValue == v) {
				return SetOperationDuplicates.values()[i];
			}
		}
		throw new Error(v);
	}

	value() {
		return this.enumValue;
	}

	getResourceId() {
		return (("SetOperationDuplicates" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/SetOperationDuplicates.js